/**
 *  @class
 *  @function ScrollingTextToggle
 */
if (!customElements.get('scrolling-text-toggle')) {
  class ScrollingTextToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.section = this.closest('.scrolling-text');
      this.button.addEventListener('click', this.onClick.bind(this));
    }

    onClick() {
      const paused = this.button.getAttribute('aria-pressed') !== 'true';
      this.button.setAttribute('aria-pressed', paused);
      this.section.classList.toggle('scrolling-text--paused', paused);
    }
  }
  customElements.define('scrolling-text-toggle', ScrollingTextToggle);
}
